import React, { useEffect } from 'react';
import { Icon } from '@iconify/react';
import { useUIStore } from '../stores/ui-store';

export function ToastContainer() {
  const toasts = useUIStore((state) => state.toasts);
  const removeToast = useUIStore((state) => state.removeToast);

  const getIcon = (type: 'success' | 'error' | 'warning' | 'info') => {
    switch (type) {
      case 'success':
        return 'lucide:check-circle';
      case 'error':
        return 'lucide:x-circle';
      case 'warning':
        return 'lucide:alert-triangle';
      case 'info':
        return 'lucide:info';
    }
  };

  const getColors = (type: 'success' | 'error' | 'warning' | 'info') => {
    switch (type) {
      case 'success':
        return 'bg-success-100 border-success-500 text-success-900 dark:bg-success-900/20 dark:text-success-100';
      case 'error':
        return 'bg-danger-100 border-danger-500 text-danger-900 dark:bg-danger-900/20 dark:text-danger-100';
      case 'warning':
        return 'bg-warning-100 border-warning-500 text-warning-900 dark:bg-warning-900/20 dark:text-warning-100';
      case 'info':
        return 'bg-primary-100 border-primary-500 text-primary-900 dark:bg-primary-900/20 dark:text-primary-100';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 max-w-md">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-start gap-3 p-4 rounded-lg border-l-4 shadow-lg backdrop-blur-sm animate-in slide-in-from-right ${getColors(
            toast.type
          )}`}
        >
          <Icon icon={getIcon(toast.type)} width={24} className="flex-shrink-0 mt-0.5" />
          <p className="flex-1 text-sm font-medium">{toast.message}</p>
          <button
            onClick={() => removeToast(toast.id)}
            className="flex-shrink-0 hover:opacity-70 transition-opacity"
          >
            <Icon icon="lucide:x" width={18} />
          </button>
        </div>
      ))}
    </div>
  );
}
